export default __webpack_public_path__ + "static/media/incoming-position.108c70d4.svg";